const ABOUT_IMG = "https://images.unsplash.com/photo-1747999613263-b9f7126471f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function About() {
  return (
    <div data-testid="page-about">
      <section className="border-b border-border bg-cream">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12 lg:py-28">
          <div className="section-label">Our story</div>
          <h1 className="mt-4 font-serif text-5xl tracking-tight sm:text-6xl">A small Alabama rabbitry with a big love for the breed.</h1>
        </div>
      </section>
      <section className="mx-auto grid max-w-7xl gap-16 px-6 py-20 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <div className="arched-mask aspect-[4/5] overflow-hidden">
            <img src={ABOUT_IMG} alt="Our rabbitry" className="h-full w-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7 space-y-6 text-base leading-relaxed text-foreground/85">
          <p>We're a small family rabbitry tucked into the foothills of northeast Alabama. We started in 2022 with a single Lionhead doe named "Honey" and have since grown — slowly, intentionally — into a working program of around a dozen breeding animals.</p>
          <p>Every rabbit here is part of the household. Our kits are born in our living room, handled daily from week two, and weaned in our enclosed indoor playroom. We don't run multiple litters at a time, and we don't sell to flippers, pet stores, or anyone we wouldn't trust with our own animals.</p>
          <p>Our breeding goals are simple: even temperament, strong type, dense mane, and a long healthy life. We test pair genetics, keep meticulous records, and cull only based on health (never appearance). When you reserve a rabbit from us, you're getting a kit we've already started to know — and we'll keep knowing, through pictures and check-ins, for as long as you'd like.</p>
          <p>Thank you for considering us. We can't wait to introduce you to your rabbit.</p>
          <div className="mt-10 border-t border-border pt-6">
            <div className="section-label">Memberships & standards</div>
            <p className="mt-3 text-sm text-stone">ARBA Member · NARBC Listed Breeder · Alabama Dept. of Agriculture compliant</p>
          </div>
        </div>
      </section>
    </div>
  );
}
